var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobFit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "job_fit-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #000000;stroke-linecap: round;stroke-miterlimit:133.3333;stroke-width: 5.8 } \n\t\t.s1 { fill: none;stroke: #000000;stroke-miterlimit:133.3333;stroke-width: 5.8 } \n\t\t.s2 { fill: none;stroke: #000000;stroke-linecap: round;stroke-miterlimit:10;stroke-width: 2.8;stroke-dasharray: 4.22387875,4.22387875 } \n\t\t.s3 { fill: none;stroke: #000000;stroke-linecap: round;stroke-miterlimit:133.3333;stroke-width: 2.8 } \n\t\t.s4 { fill: none;stroke: #000000;stroke-linecap: round;stroke-miterlimit:133.3333;stroke-width: 2.8;stroke-dasharray: 4.68759375,4.68759375 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m4.6 55.4c1.8-5.8 6.3-7.6 16.4-7.6 10.2 0 14.7 1.8 16.4 7.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m21 40.3c-4.8 0-8.8-4-8.8-8.9 0-4.9 4-8.8 8.8-8.8 4.9 0 8.9 3.9 8.9 8.8 0 4.9-4 8.9-8.9 8.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m51.6 32.6c-5.2 0-9.4-4.2-9.4-9.4 0-5.3 4.2-9.5 9.4-9.5 5.2 0 9.4 4.2 9.4 9.5 0 5.2-4.2 9.4-9.4 9.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m36.2 44.5q0.3-1.1 0.8-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m40.3 39.2c2.5-1.4 6.1-1.9 11.4-1.9 6.8 0 10.9 0.8 13.3 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m66.4 42.4q0.5 1 0.8 2.1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobFit);
export default __webpack_public_path__ + "static/media/job_fit.62d58cab24ecf1ad1dd849a571359aa4.svg";
export { ForwardRef as ReactComponent };